export * from './ModuleFE_EHRInstanceKBVersion.js';
//# sourceMappingURL=index.js.map